export enum JobCategory {
  HeadProfessional = 1,
  AssistantProfessional,
}
